import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import EcoVideo from 'eco-design/base/eco-video';
import { PlayIcon, PauseIcon, MuteIcon, VocalIcon } from './icon';
import getLocal from '@/app/utils/getLocal';

const LoopVideoSection: React.FC = () => {
    const [play, setPlay] = useState(false);
    const [muted, setMuted] = useState(true);
    const videoRef = useRef<HTMLVideoElement>(null);
    const { locale } = getLocal();
    const handlePlay = () => {
        play ? videoRef.current?.pause() : videoRef.current?.play();
        setPlay(!play);
    };

    const handleVocal = () => {
        setMuted(!muted);
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (elemA: any) => {
                const elemB = elemA[0];

                if (elemB.intersectionRatio >= 0) {
                    console.log('进入可视区');
                    videoRef.current?.play();
                    setPlay(true);
                } else {
                    console.log('离开可视区');
                    videoRef.current?.pause();
                    setPlay(false);
                }
                // if (elemB.isIntersecting) {
                //     // 进入可视区
                //     console.log('进入可视区');
                //     videoRef.current?.play();
                //     setPlay(true);
                // } else {
                //     // 离开可视区
                //     console.log('离开可视区');
                //     videoRef.current?.pause();
                //     setPlay(false);
                // }
            },
            { threshold: 0.1 },
        ); // 触发的阈值（0.1 表示 10% 可见时触发）
        const ele = document.querySelector('#loop-video');
        if (ele) observer.observe(ele);

        return () => {
            if (ele) observer.unobserve(ele);
        };
    }, []);

    return (
        <div className={styles.LoopVideoSection}>
            <div className="video-box">
                <video
                    id="loop-video"
                    ref={videoRef}
                    playsInline
                    muted={muted}
                    autoPlay={false}
                    loop
                    poster="https://websiteoss.ecoflow.com/upload/image/1749271250555/loopvideoposter.jpg"
                    className="video"
                >
                    <source
                        src={
                            locale === 'de'
                                ? 'https://websiteoss.ecoflow.com/upload/video/1750556597091/BKW%20TVC%E6%AD%A3%E5%BC%8F%E7%89%8830s-DE_H.264.mp4'
                                : 'https://websiteoss.ecoflow.com/upload/video/1750663400799/BKW%20TVC%E6%AD%A3%E5%BC%8F%E7%89%8830s-0623_H.264.mp4'
                        }
                    />
                    {/* video标签 添加css */}
                </video>
                <div className="tools">
                    {play ? <PauseIcon onClick={handlePlay} /> : <PlayIcon onClick={handlePlay} />}
                    {muted ? <MuteIcon onClick={handleVocal} /> : <VocalIcon onClick={handleVocal} />}
                </div>
            </div>
        </div>
    );
};

export default LoopVideoSection;
